import React, { useEffect, useState } from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import CommonFooter from "../components/CommonFooter/CommonFooter";
import TopEquipments from "../components/AllProdutcs/TopEquipments";
import ProductList from "../components/AllProdutcs/ProductList";
import ProductFilter from "../components/AllProdutcs/ProductFilter";
import FeatureAdds from "../components/AllProdutcs/FeatureAdds";
// import AgriMachineryStorehero from '../components/AllProdutcs/AgriMachineryStorehero'
import { getProducts } from "../services/ProductsServices";
import { getWishlistProducts } from "../services/WishlistServices";
import TopFarmlands from "../components/AllProdutcs/TopFarmlands";
import { all } from "axios";
import ShopByCategory from "../components/HomePage/ShopByCategory";
import Innovativetestimonials from "../components/innovativeFarmingSolutions/Innovativetestimonials";

const AllProduct = () => {
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [adType, setAdType] = useState("");

  const [machineryData, setMachineryData] = useState([]); // ✅ machinery products
  const [farmlandData, setFarmlandData] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  console.log("farmlandData", farmlandData);
  console.log("machinery", machineryData);
  const [favouriteItems, setFavouriteItems] = useState([]);
  const [productsToBeShown, setProductsToBeShown] = useState(12);
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLoad, setPageLoad] = useState(false);

  // Call both APIs at the same time
  const getproducts = async () => {
    try {
      const [machineryRes, farmlandRes] = await Promise.all([
        getProducts(
          "machinery",
          pageNumber,
          productsToBeShown,
          minPrice,
          maxPrice,
          adType,
          ""
        ),
        getProducts(
          "farmland",
          pageNumber,
          productsToBeShown,
          minPrice,
          maxPrice,
          adType,
          ""
        ),
      ]);
      console.log("machineryRes", machineryRes);
      console.log("farmlandRes", farmlandRes);
      setMachineryData(machineryRes?.products || []);
      setFarmlandData(farmlandRes?.products || []);
      setAllProducts([
        ...(machineryRes?.products || []),
        ...(farmlandRes?.products || []),
      ]);
      // If you want total count across both
      const total =
        (machineryRes?.totalProducts || 0) + (farmlandRes?.totalProducts || 0);
      setTotalPages(Math.ceil(total / productsToBeShown));
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const getWishlistItems = async () => {
    const tokenitem = localStorage.getItem("token");
    const res = await getWishlistProducts(tokenitem);
    setFavouriteItems(res);
  };

  useEffect(() => {
    getproducts();
    getWishlistItems();
  }, [minPrice, maxPrice, productsToBeShown, pageNumber, pageLoad]);

  const productstobeShown = (value) => {
    setProductsToBeShown(value);
  };

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected + 1);
  };

  const handleMinPriceChange = (value) => {
    setMinPrice(value);
  };

  const handleMaxPriceChange = (value) => {
    setMaxPrice(value);
  };

  const handleAdTypeChange = (value) => {
    setAdType(value);
  };

  // const filteredData = data.filter(product => {
  //   return (
  //     (adType === '' || product.adType === adType) &&
  //     (minPrice === '' || product.price >= parseFloat(minPrice)) &&
  //     (maxPrice === '' || product.price <= parseFloat(maxPrice))
  //   )
  // })

  const filterProducts = (products) => {
    return products.filter((product) => {
      return (
        (adType === "" || product.adType === adType) &&
        (minPrice === "" ||
          parseFloat(product.price) >= parseFloat(minPrice)) &&
        (maxPrice === "" || parseFloat(product.price) <= parseFloat(maxPrice))
      );
    });
  };

  const filteredMachinery = filterProducts(machineryData);
  const filteredFarmland = filterProducts(farmlandData);

  return (
    <>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      {/* <AgriMachineryStorehero /> */}
      <div className="container px-xl-5 py-5">
        <div className="row">
          <div
            className="col-lg-3 col-md-4 d-none d-md-flex flex-column-reverse flex-md-column top-0 h-100 
          side-bar-position"
          >
            {/* TODO : Filter */}

            <div
              className={{
                backgroundColor: "#f3f4f6",
                margin: 0,
                padding: "2rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              <ProductFilter
                data={allProducts}
                minPrice={minPrice}
                maxPrice={maxPrice}
                adType={adType}
                onMinPriceChange={handleMinPriceChange}
                onMaxPriceChange={handleMaxPriceChange}
                onAdTypeChange={handleAdTypeChange}
              />
            </div>

            <FeatureAdds mt5="mt-5" />
          </div>
          <div className="col-lg-9 col-md-8">
            {/* Machinery Section */}
            {machineryData.length > 0 && (
              <>
                <h3 className="mb-6 fw-bold">Machinery</h3>
                {/* <TopEquipments
                  productstobeShown={productstobeShown}
                  productsShown={productsToBeShown}
                  filterdata={machineryData}
                  minPrice={minPrice}
                  maxPrice={maxPrice}
                  adType={adType}
                  onMinPriceChange={handleMinPriceChange}
                  onMaxPriceChange={handleMaxPriceChange}
                  onAdTypeChange={handleAdTypeChange}
                /> */}
                <ProductList
                  data={filteredMachinery}
                  favouriteItems={favouriteItems}
                  getWishlistItems={getWishlistItems}
                  pageNumber={pageNumber}
                  totalPages={totalPages}
                  handlePageChange={handlePageChange}
                  productsToBeShown={productsToBeShown}
                />
              </>
            )}

            {/* Farmland Section */}
            {farmlandData.length > 0 && (
              <>
                <h3 className="mt-5 mb-3 fw-bold">Farmlands</h3>
                {/* <TopFarmlands
                  productstobeShown={productstobeShown}
                  productsShown={productsToBeShown}
                  filterdata={farmlandData}
                  minPrice={minPrice}
                  maxPrice={maxPrice}
                  adType={adType}
                  onMinPriceChange={handleMinPriceChange}
                  onMaxPriceChange={handleMaxPriceChange}
                  onAdTypeChange={handleAdTypeChange}
                /> */}
                <ProductList
                  data={filteredFarmland}
                  favouriteItems={favouriteItems}
                  getWishlistItems={getWishlistItems}
                  pageNumber={pageNumber}
                  totalPages={totalPages}
                  handlePageChange={handlePageChange}
                  productsToBeShown={productsToBeShown}
                />
              </>
            )}
          </div>
        </div>
        <ShopByCategory />
        <Innovativetestimonials />
      </div>
      <CommonFooter />
    </>
  );
};

export default AllProduct;
